import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const EnquiryContext = createContext(null);
const STORAGE_KEY = "gn_enquiry_cart_v1";

export const EnquiryProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {
      // ignore parse errors
    }
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      // ignore storage errors
    }
  }, [items, ready]);

  const addItem = (product, extras = {}) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.product_id === product.id);
      if (exists) return prev;
      return [
        ...prev,
        {
          product_id: product.id,
          product_name: product.name,
          category: product.category,
          quantity_mt: extras.quantity_mt || "",
          packaging: extras.packaging || product.packaging || "",
          incoterm: extras.incoterm || "FOB",
          destination_port: extras.destination_port || "",
        },
      ];
    });
  };

  const updateItem = (product_id, patch) => {
    setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, ...patch } : i)));
  };

  const removeItem = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clearCart = () => setItems([]);
  const hasProduct = (product_id) => items.some((i) => i.product_id === product_id);
  const count = items.length;

  const value = useMemo(
    () => ({ items, addItem, updateItem, removeItem, clearCart, hasProduct, count }),
    [items]
  );

  return <EnquiryContext.Provider value={value}>{children}</EnquiryContext.Provider>;
};

export const useEnquiry = () => {
  const ctx = useContext(EnquiryContext);
  if (!ctx) throw new Error("useEnquiry must be used inside EnquiryProvider");
  return ctx;
};
